
import Vue from 'vue';
import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { Component } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { WindowType } from '../../../../util';
import { InventoryBin, InventoryUiClient } from '../../../backend/backendapi';
import { initClient } from '../../../../api';
import BinDeleteModal from './BinDeleteModal';
import BinEditModal from './BinEditModal/BinEditModal';
import BinPrintModal from './BinPrintModal';
import BinImportModal from './BinImportModal';

declare var window: WindowType;

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'BinTab',
  components: {
    BinDeleteModal,
    BinEditModal,
    BinPrintModal,
    BinImportModal,
    VueGoodTable,
    VueSelect,
  },
})
export default class BinTab extends Vue {
  //data
  private readonly bins: InventoryBin[] = [];

  //runtime
  private readonly selectedBins: InventoryBin[] = [];

  //api
  private readonly service = initClient(InventoryUiClient);

    get canUpload(): boolean {
        return window.application.check2.isInventoryUpload;
    };

  get columnsConfig(): any[] {
    return [
      {
        label: this.$t('inventory.bin.ident').toString(),
        field: 'ident',
      },
      {
        label: this.$t('inventory.bin.name').toString(),
        field: 'name',
      },
      {
        label: this.$t('inventory.bin.locationAisle').toString(),
        field: 'locationAisle',
      },
      {
        label: this.$t('inventory.bin.locationRow').toString(),
        field: 'locationRow',
      },
      {
        label: this.$t('inventory.bin.locationPin').toString(),
        field: 'locationPin',
      },
    ];
  };

  get paginationConfig(): any {
    return {
      enabled: true,
      nextLabel: this.$t('txtNext'),
      prevLabel: this.$t('txtPrev'),
      rowsPerPageLabel: this.$t('txtPagePer'),
      ofLabel: this.$t('txtOf'),
      pageLabel: this.$t('txtPage'),
      allLabel: this.$t('txtAll'),
      perPage: 30,
    };
  }

  get selectConfig(): any {
    return {
      enabled: true,
      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
      selectionInfoClass: 'custom-class',
      selectionText: this.$t('comSelectionCnt'),
      clearSelectionText: this.$t('comClear'),
      disableSelectInfo: false, // disable the select info panel on top
      selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
    };
  }

  mounted() {
    this.fetchBins();
  }

  async fetchBins(): Promise<void> {
    const bins = await this.service.listBins(null);
    this.bins.splice(0);
    this.bins.push(...bins);
  }

  clearSelection(): void {
    this.selectedBins.splice(0);
  }

  fetchAndClear(): void {
    setTimeout(() => {
      this.fetchBins();
      this.clearSelection();
    }, 500);
  }

  openAddModal(): void {
    let newBin = InventoryBin.fromJS({
      createdAt: new Date(),
      createdBy: window.application.user.id,
      updatedAt: new Date(),
      updatedBy: window.application.user.id,
    });
    (this.$refs.editModal as BinEditModal).open(newBin, false);
  }

  openEditModal(): void {
    if (this.selectedBins.length > 0 && this.selectedBins[0].id !== undefined) {
      (this.$refs.editModal as BinEditModal).open(this.selectedBins[0], true);
    }
  }

  openDeleteModal(): void {
    (this.$refs.deleteModal as BinDeleteModal).open(this.selectedBins);
  }

  openPrintModal(): void {
    (this.$refs.printModal as BinPrintModal).open(this.selectedBins);
    }

  openImportModal(): void {
    (this.$refs.importModal as BinImportModal ).open();
  }

  //events
  onSelectionChanged(params: { selectedRows: InventoryBin[] }): void {
    this.selectedBins.splice(0);
    this.selectedBins.push(...params.selectedRows);
  }
}
